import { API } from "@/lib/api";

const VIDEO_EXTS = ["mp4", "webm", "mov", "m4v"];

export default function PostMedia({ mediaPath, consistency }) {
  if (!mediaPath) return null;
  const ext = (mediaPath.split(".").pop() || "").toLowerCase();
  const url = `${API}/files/${mediaPath}`;
  const pixel = consistency < 40 ? "pixelate-low" : "pixelate-high";
  if (VIDEO_EXTS.includes(ext)) {
    return (
      <video
        src={url}
        controls
        playsInline
        preload="metadata"
        className={`mt-3 w-full max-h-[480px] rounded bg-black ${pixel}`}
      />
    );
  }
  return (
    <img
      src={url}
      alt=""
      className={`mt-3 w-full max-h-96 object-cover rounded ${pixel}`}
    />
  );
}
